import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button, Card, Col, Form, Modal, Row } from 'react-bootstrap';
import { ValidationForm, TextInput, SelectGroup, Checkbox } from 'react-bootstrap4-form-validation';
import { useDispatch, useSelector } from 'react-redux';
import ReactDatePicker from 'react-datepicker';
import moment from 'moment';
import DataGrid, { Column, Paging, Pager, Scrolling, SearchPanel, FilterRow, HeaderFilter, ColumnChooser, ColumnFixing, Button as ActionButton, Export } from 'devextreme-react/data-grid';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import Loader from '../App/layout/Loader';
import { fetchUnitMaster } from '../store/unitMaster/unitMaster.actions';
import { UNIT_MASTER } from '../store/unitMaster/unitMaster.reducer';
import { fetchYarnPOProgramDropdown, fetchYarnPOSupplierDropdown2, fetchYarnPOPendingDeliveryAtDropdown } from '../store/programs/YarnPO/yarnPO/yarnPO.actions';
import { YARN_PO } from '../store/programs/YarnPO/yarnPO/yarnPO.reducer';
import { getIpAddress } from '../store/propertyMaster/propertyMaster.actions';
import { PROPERTY_MASTER } from '../store/propertyMaster/propertyMaster.reducer';
import {
    fetchGatePassMasterData,
    getSingleGatePass,
    createGatePassForm,
    createGatePass,
    updateGatePass,
    deleteGatePass,
    fetchGatePassStatusDropdown,
    setUnitNameGatePass,
    fetchPendingStyleSaleOrderByProgram
} from '../store/programs/GatePass/gatePass.actions';
import { GATE_PASS_USERFORM_RESET, SET_START_DATE_GATE_PASS, SET_END_DATE_GATE_PASS, NAVIGATE_GATE_PASS_DETAILS, NAVIGATE_GATE_PASS_PRINT } from '../store/programs/GatePass/gatePass.actionsType';
import { GATE_PASS } from '../store/programs/GatePass/gatePass.reducer';
import DropDownGrid from '../App/components/DropDownGrid';

export function statusChecker(c) {
    console.log(c.fldIsPrepared, '-', c.fldIsAuthorized, '-', c.fldTotalQty,'statuschecker')
    if (c.fldTotalQty === 0) {
        return 'Detail Not Entered';
    } else if (c.tblProgramMappingId.fldProgramName === 'CUTTING DC' && c.fldColors === '') {
        return 'Detail Not Entered';
    } else if (!c.fldIsPrepared) {
        return 'Not Prepared';
    } else if (c.fldIsPrepared ) {
        return 'Prepared';
   
    } else if (c.fldIsPrepared && c.fldIsAuthorized) {
        return 'Authorized';
    }
}
const allowedPageSizes = [10, 20, 50, 100];
const today = new Date();

// Ids come back from <select> as strings but from the API as numbers —
// compare as strings so both match.
const sameId = (a, b) => a !== undefined && a !== null && a !== '' && String(a) === String(b);

/**
 * Builds the multi-line address text shown in the Supplier / Delivery address
 * boxes. Empty parts are skipped so you don't get "undefined, , ...".
 */
const formatAddress = ({ address1, address2, area, city, state, pincode, phone, gstNo, panNo }) => {
    const lines = [];
    const addressLine = [address1, address2, area, city, state].filter(Boolean).join(', ');
    if (addressLine) lines.push(`${addressLine}.`);
    if (pincode) lines.push(`Pincode: ${pincode}`);
    if (phone) lines.push(`Phone: ${phone}`);
    if (gstNo) lines.push(`GST No.: ${gstNo}`);
    if (panNo) lines.push(`PAN No: ${panNo}`);
    return lines.join('\r\n');
};

// ---------- Snapshot builders (denormalized columns on TblGatePass) ----------

const buildUnitSnapshot = (unit) => ({
    fldUnitCode: unit?.fldUnitCode, // TODO: confirm field name
    fldUnitName: unit?.fldName,
    fldUnitAddress1: unit?.fldAddress1,
    fldUnitAddress2: unit?.fldAddress2,
    fldUnitFKArea: unit?.fldFKArea, // TODO: confirm field name
    fldUnitCountry: unit?.fldCountry, // TODO: confirm field name
    fldUnitState: unit?.fldState,
    fldUnitCity: unit?.fldCity,
    fldUnitArea: unit?.fldArea,
    fldUnitPincode: unit?.fldPincode,
    fldUnitGSTNo: unit?.fldGSTNo
});

// Supplier dropdown now uses the same list as Delivery At
// (pendingYarnDeliveryAtList), so the source fields are the fld* ones.
const buildSupplierSnapshot = (supplier) => ({
    fldSupplierCode: supplier?.fldCode, // TODO: confirm field name
    fldSupplierName: supplier?.fldName,
    fldSupplierAddress1: supplier?.fldAddress1,
    fldSupplierAddress2: supplier?.fldAddress2,
    fldSupplierFKArea: supplier?.fldFKArea, // TODO: confirm field name
    fldSupplierCountry: supplier?.fldCountry, // TODO: confirm field name
    fldSupplierState: supplier?.fldState,
    fldSupplierCity: supplier?.fldCity,
    fldSupplierArea: supplier?.fldArea,
    fldSupplierPincode: supplier?.fldPincode,
    fldSupplierGSTNo: supplier?.fldGSTNo,
    fldSupplierPANNo: supplier?.fldPANNo,
    fldSupplierPhoneNo: supplier?.fldPhone
});

const buildDeliveryAtSnapshot = (deliveryAt) => ({
    fldDeliveryAtCode: deliveryAt?.fldCode, // TODO: confirm field name
    fldDeliveryAtName: deliveryAt?.fldName,
    fldDeliveryAtAddress1: deliveryAt?.fldAddress1,
    fldDeliveryAtAddress2: deliveryAt?.fldAddress2,
    fldDeliveryAtFKArea: deliveryAt?.fldFKArea, // TODO: confirm field name
    fldDeliveryAtCountry: deliveryAt?.fldCountry, // TODO: confirm field name
    fldDeliveryAtState: deliveryAt?.fldState,
    fldDeliveryAtCity: deliveryAt?.fldCity,
    fldDeliveryAtArea: deliveryAt?.fldArea,
    fldDeliveryAtPincode: deliveryAt?.fldPincode,
    fldDeliveryAtGSTNo: deliveryAt?.fldGSTNo,
    fldDeliveryPhoneNo: deliveryAt?.fldPhone,
    flDeliveryAtPANNo: deliveryAt?.fldPANNo
});

// "To our Company" → Delivery At comes from our own Units (unitMaster).
const buildOurCompanyDeliverySnapshot = (unit) => ({
    fldDeliveryAtCode: unit?.fldUnitCode, // TODO: confirm field name
    fldDeliveryAtName: unit ? `${unit.fldName}${unit?.tblPropertiesunit?.fldDescription ? ` - ${unit.tblPropertiesunit.fldDescription}` : ''}` : '',
    fldDeliveryAtAddress1: unit?.fldAddress1,
    fldDeliveryAtAddress2: unit?.fldAddress2,
    fldDeliveryAtFKArea: unit?.fldFKArea, // TODO: confirm field name
    fldDeliveryAtCountry: unit?.fldCountry, // TODO: confirm field name
    fldDeliveryAtState: unit?.fldState,
    fldDeliveryAtCity: unit?.fldCity,
    fldDeliveryAtArea: unit?.fldArea,
    fldDeliveryAtPincode: unit?.fldPincode,
    fldDeliveryAtGSTNo: unit?.fldGSTNo,
    fldDeliveryPhoneNo: unit?.fldPhone, // TODO: confirm field name
    flDeliveryAtPANNo: unit?.fldPANNo // TODO: confirm field name
});

/**
 * Cleans the form before sending it to the API:
 *  - every FK field (fldFK..., FldFK..., FldUnitFKArea, FldSupplierFKArea ...) is sent as an
 *    integer; an FK that is empty, 0 or not a number is left out
 *  - fields with no value (undefined, null, empty / blank string) are left out
 *  - booleans (false) and number 0 for quantities are real values, so they stay
 */
const isFKField = (key) => /^[Ff]ld\w*FK/.test(key);

const buildPayload = (data) =>
    Object.keys(data).reduce((acc, key) => {
        let value = data[key];

         if (key === 'FldTotalQty') { value = 0 }
        if (isFKField(key)) {
            const num = parseInt(value, 10);
            if (!Number.isNaN(num) && num !== 0) acc[key] = num;
            return acc;
        }

        if (value === undefined || value === null) return acc;
        if (typeof value === 'string') {
            value = value.trim();
            if (value === '') return acc;
        }
        acc[key] = value;
        return acc;
    }, {});

const emptyDeliverySnapshot = () =>
    Object.keys(buildDeliveryAtSnapshot(null)).reduce((acc, k) => ({ ...acc, [k]: '' }), {});

const GatePassGrid = () => {
    const dispatch = useDispatch();
    const reset = useRef();
    const [showModal, setShowModal] = useState(false);
    const [mode, setMode] = useState('create'); // 'create' | 'update' | 'delete'
    const [submitted, setSubmitted] = useState(false);
    const [salesOrderDataRequired, setSalesOrderDataRequired] = useState(false);

    const { loading, unitId, startDate, endDate, gatePassMaster, gatePassForm, pendingStyleSaleOrderList } = useSelector(
        (state) => state[GATE_PASS]
    );
    const { unitMaster } = useSelector((state) => state[UNIT_MASTER]);
    const { programList, pendingYarnDeliveryAtList } = useSelector((state) => state[YARN_PO]);
    const { ipAddressInfo } = useSelector((state) => state[PROPERTY_MASTER]);

    // Rows for the list grid. Handles the two usual reasons the grid shows
    // nothing even though GetTblGatePasses returns data:
    //  1. the reducer stored the whole response object ({ data: [...] })
    //     instead of the array — DataGrid needs a plain array;
    //  2. key casing: ASP.NET returns camelCase (fldId) by default, but some
    //     endpoints/serializer settings return PascalCase (FldId). Every key is
    //     normalised to start lower-case so the columns below always match.
    const gridRows = useMemo(() => {
        const list = Array.isArray(gatePassMaster)
            ? gatePassMaster
            : gatePassMaster?.data ?? gatePassMaster?.Data ?? gatePassMaster?.result ?? gatePassMaster?.Result ?? [];
        if (!Array.isArray(list)) return [];
        return list.map((row) =>
            Object.keys(row || {}).reduce((acc, k) => {
                acc[k.charAt(0).toLowerCase() + k.slice(1)] = row[k];
                return acc;
            }, {})
        );
    }, [gatePassMaster]);

    // Supplier dropdown shows the same data as the (normal) Delivery At dropdown.
    const supplierList = pendingYarnDeliveryAtList || [];

    // Delivery At switches source when "To our Company" is ticked.
    //const isToOurCompany = !!gatePassForm?.FldIsToOurCompany;
    const isToOurCompany = true;
    const deliveryAtOptions = isToOurCompany
        ? (unitMaster || []).map((u) => ({
              id: u.fldId,
              label: `${u.fldName}${u?.tblPropertiesunit?.fldDescription ? ` - ${u.tblPropertiesunit.fldDescription}` : ''}`
          }))
        : (pendingYarnDeliveryAtList || [])
              // Supplier and Delivery At come from the same list here, so hide
              // the party already picked as Supplier.
              .filter((d) => !sameId(d.fldId, gatePassForm?.FldFKSupplierID))
              .map((d) => ({ id: d.fldId, label: d.fldName }));

    // Supplier dropdown: hide the party already picked as Delivery At
    // (only when both come from the same list, i.e. not "To our Company").
    const supplierOptions = isToOurCompany
        ? supplierList
        : supplierList.filter((s) => !sameId(s.fldId, gatePassForm?.FldFKDeliveryAt));

    const isSameSupplierAndDelivery = () =>
        !isToOurCompany && sameId(gatePassForm?.FldFKSupplierID, gatePassForm?.FldFKDeliveryAt);

    useEffect(() => {
        dispatch(fetchUnitMaster());
        dispatch(getIpAddress());
        dispatch(fetchYarnPOProgramDropdown('TblGatePass'));
        dispatch(fetchYarnPOSupplierDropdown2('TblProgramSupplier'));
        dispatch(fetchYarnPOPendingDeliveryAtDropdown());
        dispatch(
            fetchGatePassMasterData(moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), unitId)
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const search = () => {
        dispatch(
            fetchGatePassMasterData(moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), unitId)
        );
    };

    const openCreateModal = () => {
        setMode('create');
        setSubmitted(false);
        setShowModal(true);
    };

    const openEditModal = (row) => {
        setMode('update');
        setSubmitted(false);
        dispatch(getSingleGatePass(row.fldId));
        setShowModal(true);
    };

    const openDeleteModal = (row) => {
        Swal.fire({
            title: `Delete Gate Pass ${row.fldGatePassNo}?`,
            text: `Supplier: ${row.fldSupplierName || 'NA'}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(
                    deleteGatePass(
                        row.fldId,
                        moment(startDate).format('YYYY-MM-DD'),
                        moment(endDate).format('YYYY-MM-DD'),
                        unitId
                    )
                );
            }
        });
    };

    const closeModal = () => {
        setShowModal(false);
        setSubmitted(false);
        dispatch({ type: GATE_PASS_USERFORM_RESET });
    };

    // DropDownGrid identifies rows by `fldId` (same as your other screens, e.g.
    // fldId: element.FldFKSaleOrder). The pending style list has no fldId, so
    // selection never registered. Give every row a unique numeric fldId — one
    // Sale Order can have several Style/Sub Style rows, so FldFKSaleOrder alone
    // isn't unique.
    const styleGridRows = (pendingStyleSaleOrderList || []).map((row, idx) => ({ ...row, fldId: idx + 1 }));

    // Selected row id for the grid, worked out from the saved form values so it
    // also highlights correctly when editing an existing Gate Pass.
    const selectedStyleRowId =
        styleGridRows.find(
            (r) =>
                sameId(r.FldFKSaleOrder, gatePassForm?.fldFKSaleOrder) &&
                (gatePassForm?.fldFKStyle === undefined || gatePassForm?.fldFKStyle === null || gatePassForm?.fldFKStyle === '' || sameId(r.FldFKStyle, gatePassForm?.fldFKStyle))
        )?.fldId ?? '';

    const handleStyleSelect = (selected) => {
        // DropDownGrid may hand back the id, the row object, or an array — handle all.
        const picked = Array.isArray(selected) ? selected[0] : selected;
        const pickedId = picked && typeof picked === 'object' ? picked.fldId : picked;
        const row = styleGridRows.find((r) => sameId(r.fldId, pickedId));
        if (!row) return;

        dispatch(createGatePassForm('fldFKSaleOrder', row.FldFKSaleOrder));
        dispatch(createGatePassForm('fldSaleOrder', row.FldSaleOrderNumber));
        dispatch(createGatePassForm('fldFKSeason', row.FldFKSeason));
        dispatch(createGatePassForm('fldFKMainStyle', row.FldFKSubStyle));
        dispatch(createGatePassForm('fldMainStyle', row.FldStyleNumber));
        dispatch(createGatePassForm('fldFKStyle', row.FldFKStyle));
        dispatch(createGatePassForm('fldStyle', row.FldSubStyleNumber));
        // display copies used by the list grid
        dispatch(createGatePassForm('FldStyleNumber', row.FldStyleNumber));
        dispatch(createGatePassForm('FldSubStyleNumber', row.FldSubStyleNumber));
        dispatch(createGatePassForm('FldSaleOrderNumber', row.FldSaleOrderNumber));
        setSalesOrderDataRequired(false);
    };

    const dispatchSnapshot = (snapshot) => {
        Object.keys(snapshot).forEach((k) => dispatch(createGatePassForm(k, snapshot[k])));
    };

    const handleChange = (event, type, name = '') => {
        let key = name === 'searchable' ? type : event?.target?.name;
        let value = name === 'searchable' ? event.value : event?.target?.value;

        // if (type === 'FldIsReturnable') {
        //     dispatch(createGatePassForm('FldIsReturnable', event.target.checked));
        //     return;
        // }

        if (type === 'FldIsToOurCompany') {
            dispatch(createGatePassForm('FldIsToOurCompany', event.target.checked));
            // The two lists have different ids, so clear the old selection.
            dispatch(createGatePassForm('FldFKDeliveryAt', ''));
            dispatchSnapshot(emptyDeliverySnapshot());
            return;
        }

        if (type === 'FldFKUnitId') {
            const unit = unitMaster.find((u) => sameId(u.fldId, event.target.value));
            dispatch(createGatePassForm('FldFKUnitId', event.target.value));
            dispatch(createGatePassForm('FldUnitName', unit ? `${unit.fldName} - ${unit?.tblPropertiesunit?.fldDescription}` : ''));
            dispatchSnapshot(buildUnitSnapshot(unit));
            dispatch(fetchPendingStyleSaleOrderByProgram(1));
            return;
        }

        if (type === 'FldFKSupplierID') {
            const supplier = supplierList.find((s) => sameId(s.fldId, event.target.value));
            dispatch(createGatePassForm('FldFKSupplierID', event.target.value));
            dispatchSnapshot(buildSupplierSnapshot(supplier));
            return;
        }

        if (type === 'FldFKDeliveryAt') {
            dispatch(createGatePassForm('FldFKDeliveryAt', event.target.value));
            if (isToOurCompany) {
                const unit = unitMaster?.find((u) => sameId(u.fldId, event.target.value));
                dispatchSnapshot(buildOurCompanyDeliverySnapshot(unit));
            } else {
                const deliveryAt = pendingYarnDeliveryAtList?.find((d) => sameId(d.fldId, event.target.value));
                dispatchSnapshot(buildDeliveryAtSnapshot(deliveryAt));
            }
            return;
        }

        if (!key) return;
        dispatch(createGatePassForm(key, value));
    };

    const getSupplierAddressText = () => {
        const s = supplierList.find((x) => sameId(x.fldId, gatePassForm?.FldFKSupplierID));
        if (!s) return '';
        return formatAddress({
            address1: s.fldAddress1,
            address2: s.fldAddress2,
            area: s.fldArea,
            city: s.fldCity,
            state: s.fldState,
            pincode: s.fldPincode,
            phone: s.fldPhone,
            gstNo: s.fldGSTNo,
            panNo: s.fldPANNo
        });
    };

    const getDeliveryAddressText = () => {
        if (isToOurCompany) {
            const u = unitMaster?.find((x) => sameId(x.fldId, gatePassForm?.FldFKDeliveryAt));
            if (!u) return '';
            return formatAddress({
                address1: u.fldAddress1,
                address2: u.fldAddress2,
                area: u.fldArea,
                city: u.fldCity,
                state: u.fldState,
                pincode: u.fldPincode,
                phone: u.fldPhone,
                gstNo: u.fldGSTNo,
                panNo: u.fldPANNo
            });
        }
        const d = pendingYarnDeliveryAtList?.find((x) => sameId(x.fldId, gatePassForm?.FldFKDeliveryAt));
        if (!d) return '';
        return formatAddress({
            address1: d.fldAddress1,
            address2: d.fldAddress2,
            area: d.fldArea,
            city: d.fldCity,
            state: d.fldState,
            pincode: d.fldPincode,
            phone: d.fldPhone,
            gstNo: d.fldGSTNo,
            panNo: d.fldPANNo
        });
    };

    const handleErrorSubmit = (errorInputs) => {
        if (errorInputs.length !== 0) {
            toast.error('Validation Error cannot Proceed!', { autoClose: 1500 });
        }
    };

    const handleSubmit = (e, formData) => {
        e.preventDefault();
        setSubmitted(true);

        if (!gatePassForm?.fldFKSaleOrder) {
            setSalesOrderDataRequired(true);
            return toast.error('Please select a Style / Sales Order.', { autoClose: 2000 });
        }
        setSalesOrderDataRequired(false);

        if (isSameSupplierAndDelivery()) {
            return toast.error('Supplier and Delivery At cannot be the same.', { autoClose: 2000 });
        }

        const button = e?.nativeEvent?.submitter?.name;
        const payload = buildPayload({
            ...gatePassForm,
            ...formData,
            FldEnteredSysId: ipAddressInfo?.IPv4 ?? null
        });

        const from = moment(startDate).format('YYYY-MM-DD');
        const to = moment(endDate).format('YYYY-MM-DD');

        if (button === 'Create' || button === 'addNew') {
            dispatch(createGatePass(payload, from, to, unitId));
            if (button === 'Create') {
                closeModal();
            } else {
                reset.current?.resetValidationState(true);
            }
        }
        if (button === 'Update') {
            dispatch(updateGatePass(payload, from, to, unitId));
            closeModal();
        }
    };

    const renderTitleHeader = (data) => <div style={{ fontWeight: 'bold' }}>{data.column.caption}</div>;

    // Gate Pass status for the Status column. Uses the status name from the
    // API if the row has one; otherwise works it out from the lifecycle
    // fields (Inward → Gate Verified → Approved → Pending).
    // TODO: confirm these field names / status names match your backend.
    const gatePassStatus = (row) => {
        // if (row?.fldStatusName) return row.fldStatusName;
        // if (row?.fldStatus && typeof row.fldStatus === 'string') return row.fldStatus;
        // if (row?.fldIsReturnable && row?.fldReturnBy) return 'Returned';
        // if (row?.fldInwardBy) return 'Inward';
        // if (row?.fldGateVerifyBy) return 'Gate Verified';
        // if (row?.fldApprovedBy) return 'Approved';
        //if (row?.fldTotalQty === 0) return "Detail Not Entered";
        if (row?.fldIsPrepared && !row?.fldIsAuthorized) return "Prepared";
        if (row?.fldIsPrepared && row?.fldIsAuthorized) return "Authorized";
        return 'Detail Not Entered';
    };

    const statusClass = (status) =>
        ({
            Returned: 'btn-green',
            Inward: 'btn-green',
            'Gate Verified': 'btn-primary',
            Approved: 'light-blue',
            Pending: 'btn-orange'
        }[status] || 'btn-secondary');

    const renderStatusCell = (e) => {
    const status = gatePassStatus(e.row.data);

    // Map each status to its corresponding button class
    const statusClassMap = {
        'Authorized': 'btn-green',
        'Detail Not Entered': 'btn-orange',
        'Prepared': 'btn-info', // <-- Changed from 'light-blue' to 'btn-info' (or your actual button class)
        'Verified': 'btn-primary',
        'Not Prepared': 'btn-danger'
    };

    // Fallback to empty string if status doesn't match
    const buttonClass = statusClassMap[status] || '';

    return (
        <div
            style={{ width: '130px', pointerEvents: 'none' }}
            className={`btn btn-sm m-0 justify-content-center text-white ${buttonClass}`}
        >
            {status}
            {e?.row?.data?.fldInwardQty > 0 ? (
                <span>
                    <svg
                        fill="white"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 50 50"
                        width="18px"
                        height="18px"
                        style={{ marginBottom: '5px', marginLeft: '5px' }}
                    >
                        <path d="M 25 3 C 18.363281 3 13 8.363281 13 15 L 13 20 L 9 20 C 7.300781 20 6 21.300781 6 23 L 6 47 C 6 48.699219 7.300781 50 9 50 L 41 50 C 42.699219 50 44 48.699219 44 47 L 44 23 C 44 21.300781 42.699219 20 41 20 L 37 20 L 37 15 C 37 8.363281 31.636719 3 25 3 Z M 25 5 C 30.566406 5 35 9.433594 35 15 L 35 20 L 15 20 L 15 15 C 15 9.433594 19.433594 5 25 5 Z M 25 30 C 26.699219 30 28 31.300781 28 33 C 28 33.898438 27.601563 34.6875 27 35.1875 L 27 38 C 27 39.101563 26.101563 40 25 40 C 23.898438 40 23 39.101563 23 38 L 23 35.1875 C 22.398438 34.6875 22 33.898438 22 33 C 22 31.300781 23.300781 30 25 30 Z" />
                    </svg>
                </span>
            ) : null}
        </div>
    );
};

    return (
        <Row className="d-flex flex-column">
            {loading && <Loader />}
            <Col>
                <button className="addBtnPosition btn btn-primary" onClick={openCreateModal}>
                    <span className="plusAdd">+</span>
                    <span className="addAdd">ADD</span>
                </button>

                <Card>
                    <Card.Body>
                        <Form.Row style={{ marginBottom: '10px' }}>
                            <Form.Group as={Col} md="3">
                                <Form.Label>Unit</Form.Label>
                                <select
                                    className="form-control"
                                    value={unitId || ''}
                                    onChange={(e) => dispatch(setUnitNameGatePass(e.target.value))}
                                >
                                    <option value="">Please select</option>
                                    <option value="-1">SHOW ALL UNITS</option>
                                    {unitMaster?.length > 0 &&
                                        unitMaster.map((item) => (
                                            <option key={item.fldId} value={item.fldId}>
                                                {item.fldName} - {item?.tblPropertiesunit?.fldDescription}
                                            </option>
                                        ))}
                                </select>
                            </Form.Group>
                            <Form.Group as={Col} md="3">
                                <Form.Label>From Date</Form.Label>
                                <ReactDatePicker
                                    selected={startDate}
                                    dateFormat="yyyy-MM-dd"
                                    className="form-control"
                                    onChange={(date) => dispatch({ type: SET_START_DATE_GATE_PASS, payload: date })}
                                />
                            </Form.Group>
                            <Form.Group as={Col} md="3">
                                <Form.Label>To Date</Form.Label>
                                <ReactDatePicker
                                    selected={endDate}
                                    dateFormat="yyyy-MM-dd"
                                    className="form-control"
                                    onChange={(date) => dispatch({ type: SET_END_DATE_GATE_PASS, payload: date })}
                                />
                            </Form.Group>
                            <Form.Group as={Col} md="2" className="d-flex align-items-end">
                                <Button variant="primary" onClick={search}>
                                    Search
                                </Button>
                            </Form.Group>
                        </Form.Row>

                        <DataGrid
                            dataSource={gridRows}
                            keyExpr="fldId"
                            showBorders={true}
                            columnAutoWidth={true}
                            allowColumnResizing={true}
                            columnResizingMode="widget"
                            rowAlternationEnabled={true}
                            hoverStateEnabled={true}
                            stateStoring={{ enabled: true, type: 'localStorage', storageKey: 'GatePassGridState_v2' }}
                        >
                            <FilterRow visible={true} applyFilter="auto" />
                            <HeaderFilter visible={true} />
                            <SearchPanel visible={true} width={240} placeholder="Search..." />
                            <ColumnChooser enabled={true} />
                            <ColumnFixing enabled={true} />
                            <Scrolling rowRenderingMode="virtual" />
                            <Paging defaultPageSize={10} />
                            <Pager
                                visible={true}
                                showPageSizeSelector={true}
                                allowedPageSizes={allowedPageSizes}
                                showNavigationButtons={true}
                                showInfo={true}
                                infoText="Page #{0}. Total: {1} ({2} items)"
                            />

                            <Column headerCellRender={renderTitleHeader} fixed={true} dataField="fldGatePassNo" caption="Gate Pass No" />
                            <Column
                                headerCellRender={renderTitleHeader}
                                dataField="fldGatePassDate"
                                dataType="date"
                                format="dd-MMM-yy"
                                caption="Gate Pass Date"
                            />
                            {/* <Column headerCellRender={renderTitleHeader} dataField="fldSupplierName" caption="Supplier" /> */}
                            <Column headerCellRender={renderTitleHeader} dataField="fldDeliveryAtName" caption="Delivery Unit" />
                            <Column headerCellRender={renderTitleHeader} dataField="fldVehicleNO" caption="Vehicle No" />
                            <Column headerCellRender={renderTitleHeader} dataField="fldIsReturnable" caption="Returnable" dataType="boolean" />
                            <Column headerCellRender={renderTitleHeader} dataField="fldStyleNumber" caption="Style Number" />
                            <Column headerCellRender={renderTitleHeader} dataField="fldTotalQty" caption="Total Qty" />
                            <Column headerCellRender={renderTitleHeader} dataField="fldRemarks" caption="Remarks" />
                            <Column headerCellRender={renderTitleHeader} caption="Status" type="buttons" width={240}>
                                <ActionButton
                                    hint="Status"
                                    visible={true}
                                    onClick={(e) => dispatch({ type: NAVIGATE_GATE_PASS_DETAILS, payload: e.row.data })}
                                    render={renderStatusCell}
                                />
                            </Column>
                            <Column headerCellRender={renderTitleHeader} caption="Actions" type="buttons" width={140}>
                                <ActionButton
                                    text="Print"
                                    icon="print"
                                    hint="Print Gate Pass"
                                    onClick={(e) => dispatch({ type: NAVIGATE_GATE_PASS_PRINT, payload: e.row.data })}
                                />
                                <ActionButton text="Edit" icon="edit" hint="Edit" onClick={(e) => openEditModal(e.row.data)} />
                                <ActionButton
                                    cssClass="text-danger"
                                    text="Delete"
                                    icon="trash"
                                    hint="Delete"
                                    onClick={(e) => openDeleteModal(e.row.data)}
                                />
                            </Column>
                            <Export enabled={true} allowExportSelectedData={true} />
                        </DataGrid>
                    </Card.Body>
                </Card>
            </Col>

            <Modal show={showModal} onHide={closeModal} size="xl" scrollable centered backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title as="h5">{mode === 'update' ? 'Update Gate Pass' : 'Create Gate Pass'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ValidationForm ref={reset} onSubmit={handleSubmit} onErrorSubmit={handleErrorSubmit}>
                        <Form.Row>
                            <Form.Group as={Col} md="3">
                                <Form.Label htmlFor="FldFKUnitId">
                                    Unit<span className="text-danger">*</span>
                                </Form.Label>
                                <SelectGroup
                                    name="FldFKUnitId"
                                    id="FldFKUnitId"
                                    value={gatePassForm?.FldFKUnitId}
                                    required
                                    errorMessage="Please select a Unit."
                                    onChange={(e) => handleChange(e, 'FldFKUnitId')}
                                >
                                    <option value="">Please select</option>
                                    {unitMaster?.length > 0 &&
                                        unitMaster.map((item) => (
                                            <option key={item.fldId} value={item.fldId}>
                                                {item.fldName} - {item?.tblPropertiesunit?.fldDescription}
                                            </option>
                                        ))}
                                </SelectGroup>
                            </Form.Group>
                            <Form.Group as={Col} md="3">
                                <Form.Label htmlFor="fldFKProgram">
                                    Program<span className="text-danger">*</span>
                                </Form.Label>
                                <SelectGroup
                                    name="fldFKProgram"
                                    id="fldFKProgram"
                                    value={gatePassForm?.fldFKProgram}
                                    required
                                    errorMessage="Please select a Program."
                                    onChange={handleChange}
                                >
                                    <option value="">Please select</option>
                                    {programList?.length > 0 &&
                                        programList.map((item) => (
                                            <option key={item.fldId} value={item.fldId}>
                                                {item.fldProgramName}
                                            </option>
                                        ))}
                                </SelectGroup>
                            </Form.Group>
                            <Form.Group as={Col} md="3">
                                <Form.Label htmlFor="FldGatePassNo">Gate Pass No.</Form.Label>
                                <TextInput
                                    name="FldGatePassNo"
                                    id="FldGatePassNo"
                                    placeholder="Auto Generated"
                                    disabled
                                    value={gatePassForm?.FldGatePassNo}
                                    autoComplete="off"
                                />
                            </Form.Group>
                            <Form.Group as={Col} md="3">
                                <Form.Label htmlFor="FldGatePassDate">Gate Pass Date</Form.Label>
                                <TextInput
                                    name="FldGatePassDate"
                                    id="FldGatePassDate"
                                    type="date"
                                    disabled
                                    value={mode === 'create' ? today.toISOString().split('T')[0] : gatePassForm?.FldGatePassDate}
                                    autoComplete="off"
                                />
                            </Form.Group>
                        </Form.Row>
                        <hr />
                        <Form.Row>
                            <Form.Group as={Col} md="12">
                                <Form.Label htmlFor="fldFKSaleOrder">
                                    Style Number <span className="text-danger">*</span>
                                </Form.Label>
                                <div>
                                    <DropDownGrid
                                        id="fldFKSaleOrder"
                                        name="fldFKSaleOrder"
                                        disabled={mode === 'delete' || !gatePassForm?.FldFKUnitId}
                                        value={selectedStyleRowId}
                                        tableHeaderData={['Style Number', 'Sub Style Number', 'Sales Order No']}
                                        tableDataKeyName={['FldStyleNumber', 'FldSubStyleNumber', 'FldSaleOrderNumber']}
                                        isSimpleTable={true}
                                        tableBodyData={loading ? [] : styleGridRows}
                                        onChange={handleStyleSelect}
                                        isMultipleSelection={false}
                                    />
                                    {(submitted || salesOrderDataRequired) && !gatePassForm?.fldFKSaleOrder && (
                                        <Form.Row className="d-flex text-danger m-0 mt-1">{`Please Select Sale Order`}</Form.Row>
                                    )}
                                </div>
                            </Form.Group>
                        </Form.Row>
                        <hr />
                        <Form.Row>
                            {/* <Form.Group as={Col} md="4">
                                <Form.Label htmlFor="FldFKSupplierID">
                                    Supplier<span className="text-danger">*</span>
                                </Form.Label>
                                <SelectGroup
                                    name="FldFKSupplierID"
                                    id="FldFKSupplierID"
                                    value={gatePassForm?.FldFKSupplierID ?? ''}
                                    required
                                    errorMessage="Please select a Supplier."
                                    onChange={(e) => handleChange(e, 'FldFKSupplierID')}
                                >
                                    <option value="">Please select</option>
                                    {supplierOptions.map((item) => (
                                        <option key={item.fldId} value={item.fldId}>
                                            {item.fldName}
                                        </option>
                                    ))}
                                </SelectGroup>
                            </Form.Group> */}
                            <Form.Group as={Col} md="4">
                                <div className="d-flex justify-content-between align-items-start">
                                    <Form.Label htmlFor="FldFKDeliveryAt">
                                        Delivery Unit<span className="text-danger">*</span>
                                    </Form.Label>
                                    <span className="d-flex align-items-center">
                                        <input
                                            type="checkbox"
                                            id="FldIsToOurCompany"
                                            style={{ marginRight: 5 }}
                                            checked={isToOurCompany}
                                            hidden
                                            onChange={(e) => handleChange(e, 'FldIsToOurCompany')}
                                        />
                                        <label hidden htmlFor="FldIsToOurCompany" className="mb-0" style={{ cursor: 'pointer' }}>
                                            To our Company
                                        </label>
                                    </span>
                                </div>
                                <SelectGroup
                                    name="FldFKDeliveryAt"
                                    id="FldFKDeliveryAt"
                                    value={gatePassForm?.FldFKDeliveryAt ?? ''}
                                    required
                                    errorMessage="Please select Delivery At."
                                    onChange={(e) => handleChange(e, 'FldFKDeliveryAt')}
                                >
                                    <option value="">Please select</option>
                                    {deliveryAtOptions.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.label}
                                        </option>
                                    ))}
                                </SelectGroup>
                            </Form.Group>
                            <Form.Group as={Col} md="4" style={{ display: 'flex', alignItems: 'center' }}>
                                <Checkbox
                                    name="fldIsReturnable"
                                    label="Returnable"
                                    checked={!!gatePassForm?.fldIsReturnable}
                                    value={gatePassForm?.fldIsReturnable}
                                    onChange={(e) => handleChange(e, 'fldIsReturnable')}
                                />
                            </Form.Group>
                            <Form.Group as={Col} md="3">
                                <Form.Label htmlFor="FldVehicleNO">Vehicle No.</Form.Label>
                                <TextInput
                                    name="FldVehicleNO"
                                    id="FldVehicleNO"
                                    value={gatePassForm?.FldVehicleNO}
                                    onChange={handleChange}
                                    autoComplete="off"
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            {/* <Form.Group as={Col} md="6">
                                <Form.Label>Supplier Address</Form.Label>
                                <textarea className="form-control" rows="5" disabled value={getSupplierAddressText()} />
                            </Form.Group> */}
                            <Form.Group as={Col} md="6">
                                <Form.Label>Delivery Address</Form.Label>
                                <textarea className="form-control" rows="5" disabled value={getDeliveryAddressText()} />
                            </Form.Group>
                            
                        </Form.Row>
                        <hr />
                        <Form.Row>
                            
                            <Form.Group as={Col} md="3">
                                <Form.Label htmlFor="FldTakenBy">Taken By</Form.Label>
                                <TextInput name="FldTakenBy" id="FldTakenBy" value={gatePassForm?.FldTakenBy} onChange={handleChange} autoComplete="off" />
                            </Form.Group>
                            <Form.Group as={Col} md="3">
                                <Form.Label htmlFor="FldTakenDate">Taken Date</Form.Label>
                                <TextInput
                                    name="FldTakenDate"
                                    id="FldTakenDate"
                                    type="date"
                                    value={gatePassForm?.FldTakenDate}
                                    onChange={handleChange}
                                    autoComplete="off"
                                />
                            </Form.Group>
                            {gatePassForm?.fldIsReturnable && (
                                <>
                                    <Form.Group as={Col} md="3">
                                        <Form.Label htmlFor="FldReturnBy">Return By</Form.Label>
                                        <TextInput
                                            name="FldReturnBy"
                                            id="FldReturnBy"
                                            value={gatePassForm?.FldReturnBy}
                                            onChange={handleChange}
                                            autoComplete="off"
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md="3">
                                        <Form.Label htmlFor="FldReturnDate">Return Date</Form.Label>
                                        <TextInput
                                            name="FldReturnDate"
                                            id="FldReturnDate"
                                            type="date"
                                            value={gatePassForm?.FldReturnDate}
                                            onChange={handleChange}
                                            autoComplete="off"
                                        />
                                    </Form.Group>
                                </>
                            )}
                            {/* <Form.Group as={Col} md="4">
                                <Form.Label htmlFor="FldDeliveryStartDate">Delivery Date</Form.Label>
                                <TextInput
                                    name="FldDeliveryStartDate"
                                    id="FldDeliveryStartDate"
                                    type="date"
                                    value={gatePassForm?.FldDeliveryStartDate}
                                    onChange={handleChange}
                                    autoComplete="off"
                                />
                            </Form.Group> */}
                            {/* <Form.Group as={Col} md="4">
                                <Form.Label htmlFor="FldPurpose">Purpose</Form.Label>
                                <TextInput
                                    name="FldPurpose"
                                    id="FldPurpose"
                                    value={gatePassForm?.FldPurpose}
                                    onChange={handleChange}
                                    autoComplete="off"
                                />
                            </Form.Group> */}
                        </Form.Row>
                       
                        {/* <Form.Row>
                            <Form.Group as={Col} md="3">
                                <Form.Label htmlFor="FldTotalQty">Total Qty</Form.Label>
                                <TextInput
                                    name="FldTotalQty"
                                    id="FldTotalQty"
                                    type="number"
                                    disabled
                                    style={{ textAlign: 'right' }}
                                    value={gatePassForm?.FldTotalQty ?? 0}
                                    autoComplete="off"
                                />
                            </Form.Group>
                        </Form.Row> */}                       
                        <hr />
                        <Form.Row>
                            <Form.Group as={Col} md="12">
                                <Form.Label htmlFor="FldRemarks">Remarks</Form.Label>
                                <TextInput
                                    name="FldRemarks"
                                    id="FldRemarks"
                                    value={gatePassForm?.FldRemarks}
                                    onChange={handleChange}
                                    autoComplete="off"
                                />
                            </Form.Group>
                            <Form.Group as={Col} sm={12} className="d-flex justify-content-around">
                                <Button variant="secondary" onClick={closeModal}>
                                    Close
                                </Button>
                                {mode === 'create' && (
                                    <>
                                        <Button type="submit" variant="primary" name="addNew" value="addNew">
                                            Save & Add New
                                        </Button>
                                        <Button variant="info" type="submit" name="Create" value="Create">
                                            Save & Close
                                        </Button>
                                    </>
                                )}
                                {mode === 'update' && (
                                    <Button variant="info" type="submit" name="Update" value="Update">
                                        Update
                                    </Button>
                                )}
                            </Form.Group>
                        </Form.Row>
                    </ValidationForm>
                </Modal.Body>
            </Modal>
        </Row>
    );
};

export default GatePassGrid;
